import React from "react";
import { toJalaliDate } from "../../utils/dateUtils";
import { useAuth } from "../../context/AuthContext";

function RequestComponent({ request, onQuickAction, onView, onViewProfile }) {
  const { user } = useAuth();
  const myFlow = request.flows?.find(
    (f) => f.status === 'pending' && (!user || Number(f.receiver) === Number(user.id))
  );

  return (
    <div className="border border-slate-100 rounded-xl p-3 bg-white shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
            <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          </div>
          <span className="text-sm font-bold text-slate-700 truncate">{request.title}</span>
        </div>
      </div>

      {request.creator_name && (
        <button
          type="button"
          onClick={() => onViewProfile && onViewProfile(request.creator)}
          className="flex items-center gap-2 mb-2 hover:bg-slate-50 rounded-lg p-1 -m-1 transition-colors"
        >
          <img
            src={`https://ui-avatars.com/api/?name=${encodeURIComponent(request.creator_name)}&background=random&color=fff&size=64`}
            alt={request.creator_name}
            className="w-6 h-6 rounded-full object-cover"
          />
          <span className="text-[11px] text-slate-500">
            درخواست‌دهنده: <span className="font-bold text-slate-700">{request.creator_name}</span>
          </span>
        </button>
      )}

      <div className="text-[11px] text-slate-500 mb-3">
        {toJalaliDate(request.created_at)}
      </div>

      {myFlow && (
        <div className="grid grid-cols-2 gap-2 mb-2">
          <button
            onClick={() => onQuickAction(myFlow.id, 'approved', 'درخواست تایید شد.')}
            className="py-1.5 px-3 rounded-lg bg-green-50 text-green-700 hover:bg-green-100 text-xs font-bold"
          >
            تایید
          </button>
          <button
            onClick={() => onQuickAction(myFlow.id, 'rejected', 'درخواست رد شد.')}
            className="py-1.5 px-3 rounded-lg bg-rose-50 text-rose-600 hover:bg-rose-100 text-xs font-bold"
          >
            رد
          </button>
        </div>
      )}

      <button
        onClick={onView}
        className="w-full py-2 bg-indigo-600 text-white hover:bg-indigo-700 text-xs font-bold rounded-lg transition-colors"
      >
        نمایش
      </button>
    </div>
  );
}

export default RequestComponent;